import { post, get, patch } from 'services';
import routes from './routes';

const UserServices = {
  createUser: async (obj) => {
    const data = await post(routes.createUser, obj);
    return data;
  },
  getUsers: async (params) => {
    const data = await get(routes.getUsers, params);
    return data;
  },
  updateUser: async (obj) => {
    const data = await patch(routes.updateUser, obj);
    return data;
  },
  updateUserStatus: async (obj) => {
    const data = await post(routes.updateUserStatus, obj);
    return data;
  },
  getUserPermissions: async (params) => {
    const data = await get(routes.getUserPermissions, params);
    return data;
  },
  updateMobilePermission: async (obj) => {
    const data = await patch(routes.updateMobilePermission, obj);
    return data;
  },
  getMobilePermissions: async (params) => {
    const data = await get(routes.getMobilePermissions, params);
    return data;
  },
  updateExecAppPermission: async (obj) => {
    const data = await patch(routes.updateExecAppPermission, obj);
    return data;
  },
  getExecAppPermissions: async (params) => {
    const data = await get(routes.getExecAppPermissions, params);
    return data;
  },
  getRelationshipManager: async (params) => {
    const data = await get(routes.getRelationshipManager, params);
    return data;
  },

  
}

export default UserServices